// TODO: заменить frontend-справочник на backend options/human_* поля транспорта
// Сейчас это fallback для ЭДО и UI, чтобы codes не попадали в документы
export const vehicleTypeOptions = () => [
  { value: "tractor", label: "Основное средство" },
  { value: "trailer", label: "Прицеп" },
  { value: "other", label: "Другое" },
];

export const trailerTypeOptions = () => [
  { value: "tent", label: "Тентованный" },
  { value: "board", label: "Бортовой" },
  { value: "fridge", label: "Рефрижераторный" },
  { value: "container", label: "Контейнерный" },
  { value: "trawl", label: "Трал" },
  { value: "dumper", label: "Самосвальный" },
  { value: "cistern", label: "Цистерна" },
  { value: "car_carrier", label: "Автовоз" },
  { value: "van", label: "Фургон" },
  { value: "platform", label: "Платформенный" },
  { value: "log_carrier", label: "Лесовоз" },
  { value: "cattle", label: "Скотовоз" },
  { value: "grain", label: "Зерновоз" },
  { value: "other", label: "Другое" },
];

export const vehicleTypeLabels = () =>
  Object.fromEntries(
    vehicleTypeOptions().map((option) => [option.value, option.label])
  );

export const trailerTypeLabels = () =>
  Object.fromEntries(
    trailerTypeOptions().map((option) => [option.value, option.label])
  );

export function vehicleTypeLabel(value) {
  if (!value) return "";

  return vehicleTypeLabels()[value] || value;
}

export function trailerTypeLabel(value) {
  if (!value) return "";

  return trailerTypeLabels()[value] || value;
}
